import { render, staticRenderFns } from "./Imputaciones.vue?vue&type=template&id=6bc3499c"
import script from "./Imputaciones.vue?vue&type=script&lang=js"
export * from "./Imputaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports